module.exports = __webpack_public_path__ + "img/img-default.8a78341c.svg";